import React, { ReactNode } from 'react'

import { FaArrowRight } from 'react-icons/fa'

import {
  PersonAction,
  PersonAvatar,
  PersonCardContainer,
  PersonContent,
} from './styles'

interface PersonCardProps {
  name: string
  description: string
  image: string
  imageAlt?: string
  actionLabel: string
  onAction: () => void
  descriptionIcon?: ReactNode
  tags?: string[]
}

const PersonCard = ({
  actionLabel,
  description,
  descriptionIcon,
  image,
  imageAlt = '',
  name,
  onAction,
  tags = [],
}: PersonCardProps) => (
  <PersonCardContainer
    type="button"
    aria-label={actionLabel}
    onClick={onAction}
  >
    <PersonAvatar>
      <img src={image} alt={imageAlt} />
    </PersonAvatar>
    <PersonContent>
      <strong>{name}</strong>
      {description && (
        <span>
          {descriptionIcon}
          {description}
        </span>
      )}
      {tags.length > 0 && (
        <div className="person-tags" aria-label="Tipos de clase">
          {tags.map((tag) => (
            <small key={tag}>{tag}</small>
          ))}
        </div>
      )}
    </PersonContent>
    <PersonAction aria-hidden="true">
      <FaArrowRight aria-hidden="true" />
    </PersonAction>
  </PersonCardContainer>
)

export default PersonCard
